import React from 'react';

const ButtonLoadingSpinner = ({ size = 24, strokeWidth = 2 }) => {
  return (
    <div style={{ width: size, height: size, display: 'inline-block' }}>
      <svg viewBox="0 0 120 120" style={{ width: '100%', height: '100%' }}>
        <defs>
          <linearGradient id="gold-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#D4AF37" />
            <stop offset="50%" stopColor="#FFD700" />
            <stop offset="100%" stopColor="#D4AF37" />
          </linearGradient>
        </defs>

        {/* Diamond outline */}
        <rect
          className="animate-draw-outline"
          x="20" y="20" width="80" height="80"
          fill="none" stroke="currentColor" strokeWidth={strokeWidth}
          transform="rotate(45 60 60)"
        />

        {/* Y shape */}
        <path
          className="animate-draw-y"
          d="M40 55 L60 75 L80 55 M60 75 L60 85"
          fill="none" stroke="currentColor" strokeWidth={strokeWidth * 1.25} strokeLinecap="round" strokeLinejoin="round"
        />

        {/* V shape */}
        <path
          className="animate-draw-v"
          d="M48 48 L60 60 L72 48"
          fill="none" stroke="currentColor" strokeWidth={strokeWidth * 1.25} strokeLinecap="round" strokeLinejoin="round"
        />

        {/* Triangle pointing right */}
        <polygon 
          className="animate-fade"
          points="58,38 58,44 64,41"
          fill="currentColor"
        />
      </svg>
      <style>{`
        @keyframes drawOutline {
          0% { stroke-dashoffset: 320; }
          25%, 100% { stroke-dashoffset: 0; }
        }
        @keyframes drawY {
          0%, 25% { stroke-dashoffset: 80; }
          50%, 100% { stroke-dashoffset: 0; }
        }
        @keyframes drawV {
          0%, 50% { stroke-dashoffset: 40; }
          75%, 100% { stroke-dashoffset: 0; }
        }
        @keyframes fade {
          0%, 75% { opacity: 0; }
          100% { opacity: 1; }
        }
        .animate-draw-outline {
          stroke-dasharray: 320;
          animation: drawOutline 4s linear infinite;
        }
        .animate-draw-y {
          stroke-dasharray: 80;
          animation: drawY 4s linear infinite;
        }
        .animate-draw-v {
          stroke-dasharray: 40;
          animation: drawV 4s linear infinite;
        }
        .animate-fade {
          animation: fade 4s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default ButtonLoadingSpinner;